<template>
  <div class="home">
    <HeroSection />
    <AboutSection />
    <BusinessSection />
    <ProductServicesSection />
    <ProductsSection />
    <NewsSection />
    <ContactSection />
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue'
import AboutSection from '@/components/AboutSection.vue'
import BusinessSection from '@/components/BusinessSection.vue'
import ProductServicesSection from '@/components/ProductServicesSection.vue'
import ProductsSection from '@/components/ProductsSection.vue'
import NewsSection from '@/components/NewsSection.vue'
import ContactSection from '@/components/ContactSection.vue'

export default {
  name: 'Home',
  components: {
    HeroSection,
    AboutSection,
    BusinessSection,
    ProductServicesSection,
    ProductsSection,
    NewsSection,
    ContactSection
  }
}
</script>
